shadow$provide[524] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, body:{enumerable:true, get:function() {
  return body;
}}, build:{enumerable:true, get:function() {
  return build;
}}, call:{enumerable:true, get:function() {
  return call;
}}, dedupe:{enumerable:true, get:function() {
  return dedupe;
}}, define:{enumerable:true, get:function() {
  return define;
}}, defuse:{enumerable:true, get:function() {
  return defuse;
}}, fn:{enumerable:true, get:function() {
  return fn;
}}, hoist:{enumerable:true, get:function() {
  return hoist;
}}, invoke:{enumerable:true, get:function() {
  return invoke;
}}, lines:{enumerable:true, get:function() {
  return lines;
}}, link:{enumerable:true, get:function() {
  return link;
}}, links:{enumerable:true, get:function() {
  return links;
}}, list:{enumerable:true, get:function() {
  return list;
}}, same:{enumerable:true, get:function() {
  return same;
}}, statements:{enumerable:true, get:function() {
  return statements;
}}, unshadow:{enumerable:true, get:function() {
  return unshadow;
}}});
var Graph = require("../graph");
var $ = require("./constants");
function unshadow(name) {
  const real = name.replace($.SHADOW_ARG, "");
  if (real !== name) {
    return real;
  } else {
    return null;
  }
}
function lines(lines) {
  return lines.join("\n");
}
function list(lines) {
  return lines.join(", ");
}
function statements(lines) {
  return lines.join(";\n");
}
function body(entry) {
  return {entry, type:"void", params:[], signature:[], return:"", vars:{}, calls:[], post:[], chain:{},};
}
function define(a, b) {
  return `#define ${a} ${b}`;
}
function fn(type, entry, params, vars, calls) {
  return `${type} ${entry}(${params}) {\n${vars}${calls}}`;
}
function invoke(ret, entry, args) {
  ret = ret ? `${ret} = ` : "";
  args = list(args);
  return `  ${ret}${entry}(${args})`;
}
function same(a, b) {
  for (let i = 0; i < a.length; i++) {
    const A = a[i];
    const B = b[i];
    if (!B) {
      return false;
    }
    if (A.type !== B.type) {
      return false;
    }
    if (A.name === $.RETURN_ARG !== (B.name === $.RETURN_ARG)) {
      return false;
    }
  }
  return true;
}
function call(lookup, dangling, entry, signature, body) {
  const args = [];
  let ret = "";
  for (let arg of Array.from(signature)) {
    let id, shadow;
    const {name} = arg;
    let copy = id = lookup(name);
    let other = null;
    let meta = null;
    let omit = false;
    const isReturn = name === $.RETURN_ARG;
    if (shadow = arg.meta != null ? arg.meta.shadowed : undefined) {
      other = lookup(shadow);
      if (other) {
        body.vars[other] = "  " + arg.param(other);
        body.calls.push(`  ${other} = ${id}`);
        if (!dangling(shadow)) {
          arg = arg.split();
        } else {
          meta = {shadowed:other};
        }
      }
    }
    if (shadow = arg.meta != null ? arg.meta.shadow : undefined) {
      other = lookup(shadow);
      if (other) {
        if (!dangling(shadow)) {
          arg = arg.split();
          omit = true;
        } else {
          meta = {shadow:other};
          continue;
        }
      }
    }
    if (isReturn) {
      ret = id;
    } else if (!omit) {
      args.push(other != null ? other : id);
    }
    if (dangling(name)) {
      let op = "push";
      if (isReturn) {
        if (body.return === "") {
          op = "unshift";
          copy = name;
          body.type = arg.spec;
          body.return = `  return ${id}`;
          body.vars[id] = "  " + arg.param(id);
        } else {
          body.vars[id] = "  " + arg.param(id);
          body.params.push(arg.param(id, true));
        }
      } else {
        body.params.push(arg.param(id, true));
      }
      arg = arg.copy(copy, meta);
      body.signature[op](arg);
    } else {
      body.vars[id] = "  " + arg.param(id);
    }
  }
  return body.calls.push(invoke(ret, entry, args));
}
function build(body, calls) {
  const {entry} = body;
  let code = null;
  if (calls && calls.length === 1 && entry !== "main") {
    const b = calls[0].module;
    if (same(body.signature, b.main.signature)) {
      code = define(entry, b.entry);
    }
  }
  if (code == null) {
    let vars = (() => {
      const result = [];
      for (const v in body.vars) {
        const decl = body.vars[v];
        result.push(decl);
      }
      return result;
    })();
    ({calls} = body);
    const {post} = body;
    let {params} = body;
    const {type} = body;
    const ret = body.return;
    calls = calls.concat(post);
    if (ret !== "") {
      calls.push(ret);
    }
    calls.push("");
    if (vars.length) {
      vars.push("");
      vars = statements(vars) + "\n";
    } else {
      vars = "";
    }
    calls = statements(calls);
    params = list(params);
    code = fn(type, entry, params, vars, calls);
  }
  return {signature:body.signature, code, name:entry,};
}
function links(links) {
  const out = {defs:[], bodies:[],};
  for (const l of Array.from(links)) {
    link(l, out);
  }
  out.defs = lines(out.defs);
  out.bodies = statements(out.bodies);
  if (out.defs === "") {
    delete out.defs;
  }
  if (out.bodies === "") {
    delete out.bodies;
  }
  return out;
}
const link = (link, out) => {
  let arg, list;
  const {module, name, external} = link;
  const {main} = module;
  const {entry} = module;
  if (same(main.signature, external.signature)) {
    return out.defs.push(define(name, entry));
  }
  const ins = [];
  const outs = [];
  let map = {};
  const returnVar = [module.namespace, $.RETURN_ARG].join("");
  for (arg of Array.from(external.signature)) {
    list = arg.inout === Graph.IN ? ins : outs;
    list.push(arg);
  }
  for (arg of Array.from(main.signature)) {
    list = arg.inout === Graph.IN ? ins : outs;
    const other = list.shift();
    let _name = other.name;
    if (_name === $.RETURN_ARG) {
      _name = returnVar;
    }
    map[arg.name] = _name;
  }
  let _lookup = name => map[name];
  const _dangling = () => true;
  const inner = body();
  call(_lookup, _dangling, entry, main.signature, inner);
  inner.entry = entry;
  map = {return:returnVar};
  _lookup = name => map[name] != null ? map[name] : name;
  const outer = body();
  call(_lookup, _dangling, entry, external.signature, outer);
  outer.calls = inner.calls;
  outer.entry = name;
  out.bodies.push(build(inner).code.split(" {")[0]);
  return out.bodies.push(build(outer).code);
};
function defuse(code) {
  const re = /([A-Za-z0-9_]+\s+)?[A-Za-z0-9_]+\s+[A-Za-z0-9_]+\s*\([^)]*\)\s*;\s*/gm;
  const strip = code => code.replace(re, _m => "");
  const blocks = code.split(/(?=[{}])/g);
  let level = 0;
  for (let i = 0; i < blocks.length; i++) {
    const b = blocks[i];
    switch(b[0]) {
      case "{":
        level++;
        break;
      case "}":
        level--;
        break;
    }
    if (level === 0) {
      const hash = b.split(/^[ \t]*#/m);
      for (let j = 0; j < hash.length; j++) {
        let line = hash[j];
        if (j > 0) {
          line = line.split(/\n/);
          const head = line.shift();
          const rest = line.join("\n");
          hash[j] = [head, strip(rest)].join("\n");
        } else {
          hash[j] = strip(line);
        }
      }
      blocks[i] = hash.join("#");
    }
  }
  return code = blocks.join("");
}
function dedupe(code) {
  const map = {};
  const re = /((attribute|uniform|varying)\s+)[A-Za-z0-9_]+\s+([A-Za-z0-9_]+)\s*(\[[^\]]*\]\s*)?;\s*/gm;
  return code.replace(re, function(m, qual, type, name, _struct) {
    if (map[name]) {
      return "";
    }
    map[name] = true;
    return m;
  });
}
function hoist(code) {
  const filter = function(lines, re) {
    const defs = [];
    const out = [];
    for (const line of Array.from(lines)) {
      const list = line.match(re) ? defs : out;
      list.push(line);
    }
    return defs.concat(out);
  };
  let lines = code.split("\n");
  lines = filter(lines, /^#define ([^ ]+ _pg_[0-9]+_|_pg_[0-9]+_ [^ ]+)$/);
  lines = filter(lines, /^#extension/);
  return lines.join("\n");
}

};